
export const getTypeName = (type: number) => {
    if (type === 0) {
        return 'Prilozi';
    }
    else if (type === 1) {
        return "Umaci";
    } else if (type === 2) {
        return "Dodaci";
    }
}